// ProductsAll.js
import React, { useContext, useState } from "react";
import { ProductsContext } from "./ProductContextProvider";
import { Link } from "react-router-dom";
import useCartStore from "../store/shoppingCardStore";
import { ShoppingCart, Plus, Minus } from "lucide-react";
import "../styles/ProductsAll.css";
import { slugify } from "../utils/utils"; // Import slugify

const ProductsAll = () => {
  const products = useContext(ProductsContext);
  const { items, itemscount, addItem, removeItem } = useCartStore();
  const nameitem = items.map((item) => item.name);

  // حالت فیلتر
  const [filter, setFilter] = useState("all"); // 'all', 'ups', 'varian'

  // فیلتر کردن محصولات بر اساس انتخاب کاربر
  const filteredProducts = products.products.filter((item) => {
    if (filter === "all") return true;
    if (filter === "ups") return item.name.toLowerCase().includes("ups");
    if (filter === "varian") return item.name.toLowerCase().includes("varian");
    return true;
  });

  // تابع برای بررسی موجود بودن محصول
  const isProductAvailable = (productName) => {
    return !productName.includes("(ناموجود)");
  };

  return (
    <div className="products-page">
      {/* فیلتر محصولات */}
      <div className="products-filter">
        <button
          className={`filter-btn ${filter === "all" ? "active" : ""}`}
          onClick={() => setFilter("all")}
        >
          تمام محصولات
        </button>
        <button
          className={`filter-btn ${filter === "ups" ? "active" : ""}`}
          onClick={() => setFilter("ups")}
        >
          باتری UPS
        </button>
        <button
          className={`filter-btn ${filter === "varian" ? "active" : ""}`}
          onClick={() => setFilter("varian")}
        >
          باتری خودرو
        </button>
      </div>

      <div className="products-grid">
        {filteredProducts.map((item) => (
          <div key={item.id} className="product-card">
            <Link
              to={`/product/${slugify(item.name)}`}
              className="product-image-link"
            >
              <img
                src={item.image[0]}
                alt={item.name}
                className="product-image"
              />
              <div className="productOverlay">
                <span>مشاهده جزئیات</span>
              </div>
            </Link>
            <div className="product-details">
              <h3 className="product-title">
                <Link
                  to={`/product/${slugify(item.name)}`}
                  className="product-name-link"
                >
                  {item.name}
                </Link>
                <span className="product-category">
                  {item.name.toLowerCase().includes("ups")
                    ? "باتری - UPS"
                    : "باتری - خودرو"}
                </span>
              </h3>

              <p className="product-price">
                <span className="price-label">قیمت: </span>
                {item.price.toLocaleString()} تومان
              </p>

              {!isProductAvailable(item.name) ? (
                <div className="out-of-stock">ناموجود</div>
              ) : nameitem.includes(item.name) ? (
                <div className="quantity-control">
                  <button
                    onClick={() => removeItem(item.id)}
                    className="quantity-btn"
                    aria-label="کاهش تعداد"
                  >
                    <Minus size={16} />
                  </button>
                  <span className="quantity-count">{itemscount[item.id]}</span>
                  <button
                    onClick={() => addItem(item)}
                    className="quantity-btn"
                    aria-label="افزایش تعداد"
                  >
                    <Plus size={16} />
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => addItem(item)}
                  className="add-to-cart-btn"
                >
                  <ShoppingCart size={18} />
                  افزودن به سبد خرید
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsAll;
